import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';
import { CAMPAIGNS_ENDPOINT } from './GetCampaigns';

/**
 * One campaign with its nested configuration — mechanism spec, targeting rule,
 * quota caps — as `GET /v1/admin/campaigns/:id` returns it. Read-only.
 */
export const getCampaign = async (campaignId) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(`${CAMPAIGNS_ENDPOINT}/${campaignId}`, { headers });

  return response.data;
};
